import FormGenerator from './FormGenerator';

export default FormGenerator;
